import { TvVideoControl } from './libs/tvVideoCVontrol';
import { TvSwiper } from './libs/swiper';

document.addEventListener('DOMContentLoaded', function () {
  const tv = new Tv();
});

class Tv {
  constructor() {
    this.tvSwiper = new TvSwiper('.js-tv-swiper');

    this.themePath = themePath;
    this.tvVideoControl = new TvVideoControl(this.themePath);
  }
}
